export const PURCHASE_ORDER_STATUS_TO_LABEL = {
  open: 'Open',
  sent: 'Sent to supplier',
  received: 'Received',
  partiallyReceived: 'Partially received',
  paid: 'Completed',
} as const;

export const PURCHASE_ORDER_STATUS_TO_ACTION = {
  open: 'REVIEW AND SEND',
  sent: 'MARK AS RECEIVED',
  received: 'PAY VENDOR',
  partiallyReceived: 'UPDATE RECEIPT',
  paid: 'VIEW INVOICE',
} as const;

export const PURCHASE_ORDER_SEND_CC_EMAILS = (
  process.env.REACT_APP_PURCHASE_ORDER_SEND_CC_EMAILS ?? ''
)
  .split(',')
  .map((email) => email.trim())
  .filter(Boolean);

export const PURCHASE_ORDER_SEND_BCC_EMAILS = (
  process.env.REACT_APP_PURCHASE_ORDER_SEND_BCC_EMAILS ?? ''
)
  .split(',')
  .map((email) => email.trim())
  .filter(Boolean);

export type PurchaseOrderStatus = keyof typeof PURCHASE_ORDER_STATUS_TO_LABEL;
export type PurchaseOrderStatusAction = keyof typeof PURCHASE_ORDER_STATUS_TO_ACTION;
